import { Space, Typography } from "antd";
import BackButton from "components/shared/BackButton";
const { Title } = Typography;

/**
 * @param {React.ReactNode} [actions]
 *   Page-level controls (export, print, a create button) placed beside Back. Optional, so
 *   existing callers that pass only a title are unaffected.
 * @param {React.ReactNode} [description]
 *   One muted line under the title saying what the page shows. Optional.
 */
const HeaderWithBack = ({ title, description, actions }) => {
  return (
    <div>
      {/* --- Header with Actions --- */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: description ? "flex-start" : "center",
          marginBottom: 20,
          flexWrap: "wrap",
          gap: 12,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div>
            <Title
              level={3}
              style={{
                color: "rgb(var(--color-ink))",
                margin: 0,
                fontWeight: 700,
              }}
            >
              {title}
            </Title>
            {description && (
              <p className="mt-1.5 mb-0 text-[13px] leading-relaxed text-text-muted">
                {description}
              </p>
            )}
          </div>
        </div>
        <Space>
          {actions}
          <BackButton />
        </Space>
      </div>
    </div>
  );
};

export default HeaderWithBack;
